// @flow
import React from 'react';
import { Wrapper, ALink } from './footer.styles';
type Props = {};

export default (props: Props) => (
  <Wrapper>
    created by{' '}
    <ALink href="http://planes.agency" target="_blank">
      planes{' '}
      <span role="img" aria-label="Plane emoji">
        ✈️
      </span>
    </ALink>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/footer/index.js